export default __webpack_public_path__ + "static/media/Raion3.4bde4fbd.png";